<template>
  <div
    class="fullscreen bg-blue text-white text-center q-pa-md flex flex-center"
  >
    <div>
      <div style="font-size: 30vh">404</div>

      <div class="text-h2" style="opacity: 0.4">
        Désolé, cette page n'existe pas (ou pas encore)...
      </div>

      <q-btn
        class="q-mt-xl"
        color="white"
        text-color="blue"
        unelevated
        to="/"
        label="Retour à l'accueil"
        no-caps
      />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
